import React from 'react';
import { COLORS } from '../../styles/variables';

interface InfoIconProps {
  size?: number;
  color?: string;
  statusIcon?: boolean;
}

const InfoIcon: React.FC<InfoIconProps> = ({ size = 24, color = COLORS.black, statusIcon }) => {
  const iconColor = statusIcon ? COLORS.grey60 : color;
  return (
    <svg width={size} viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <path
        id="infoIcon"
        d="M11.5,17 L11.5,10 M11.5,8 L11.5,6 M11.5,22.5 C17.5751322,22.5 22.5,17.5751322 22.5,11.5 C22.5,5.42486775 17.5751322,0.5 11.5,0.5 C5.42486775,0.5 0.5,5.42486775 0.5,11.5 C0.5,17.5751322 5.42486775,22.5 11.5,22.5 Z"
        stroke={iconColor}
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      />
    </svg>
  );
};

export default InfoIcon;
